export enum AgreementChangeReasonTypeEnum {
  EXTENSION = 1,
  CHANGE = 2,
}
